import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { validatePermission } from 'actions';
import ApplicationLayout from 'v3/layouts/Application';
import Space from 'v3/components/Space';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import { usePermission } from 'hooks';
import { Data } from './Data';
import { OwnerData } from './Owner';
import { Attachments } from './Attachments';

export function VehicleBodiesDetails() {
  const navigate = useNavigate();
  const [attachments, setAttachments] = useState([]);
  const hasPermissionToCreate = validatePermission('CADASTRAR_CARROCERIA');

  usePermission('VISUALIZAR_CARROCERIA', {
    redirect: true,
  });

  return (
    <ApplicationLayout
      title="Carroceria"
      RightComponent={
        <Space x="0.5rem">
          <Button variant="secondary" onClick={() => navigate(-1)}>
            <Text color="dark" weight={500} type="regular">
              Voltar
            </Text>
          </Button>
          {hasPermissionToCreate ? (
            <>
              <Button
                variant="primary"
                onClick={() => {
                  navigate('/carrocerias/cadastrar');
                }}
                style={{ minHeight: 44 }}
              >
                <Text weight={500} color="white" type="regular">
                  Nova Carroceria
                </Text>
              </Button>
            </>
          ) : null}
        </Space>
      }
    >
      <Row>
        <Col md={6} xs={12}>
          <Data />
        </Col>
        <Col md={6} xs={12}>
          <OwnerData />
        </Col>
        <Col md={6} xs={12} />
      </Row>
      <Row>
        <Col md={12}>
          <Attachments
            attachments={attachments}
            setAttachments={setAttachments}
          />
        </Col>
      </Row>
    </ApplicationLayout>
  );
}
